import { isDevelopment, isTest } from '@quadminds/shared/utils';
import { FirebaseOptions, initializeApp } from 'firebase/app';
import {
    browserSessionPersistence,
    connectAuthEmulator,
    createUserWithEmailAndPassword,
    getAuth,
    setPersistence,
} from 'firebase/auth';

const EMULATOR_URI = 'http://127.0.0.1:9099';

const firebaseConfigTest: FirebaseOptions = {
    apiKey: 'AIzaSyDokomBb8WGtX6ysUTgXJntVJRfvx8LC2E',
    authDomain: 'qm-identity-platform-test.firebaseapp.com',
    projectId: 'qm-identity-platform-test',
    storageBucket: 'qm-identity-platform-test.appspot.com',
    messagingSenderId: '631367305215',
    appId: '1:631367305215:web:ba4df77801cbd3997109ca',
};

const firebaseConfig: FirebaseOptions = {
    apiKey: 'AIzaSyBuLcZazTTkZedsGtZQVq8RkW5fwaHsxjM',
    authDomain: 'qm-identity-platform.firebaseapp.com',
    projectId: 'qm-identity-platform',
    storageBucket: 'qm-identity-platform.appspot.com',
    messagingSenderId: '760783340649',
    appId: '1:760783340649:web:3ea1d7327f1de1c5b5cef8',
};

const app = initializeApp(isTest() || isDevelopment() ? firebaseConfigTest : firebaseConfig);

export const auth = getAuth(app);
const shouldUseEmulator = window.location.hostname.includes('local') && isTest();
if (shouldUseEmulator) {
    connectAuthEmulator(auth, EMULATOR_URI);
    const email = 'test@gmail.com';
    const password = '123456';
    createUserWithEmailAndPassword(auth, email, password).catch(() => undefined);
}

setPersistence(auth, browserSessionPersistence);
